import { SLIDER_MARGIN } from "../../constants";
const SLIDER_MARGIN_PX = `${SLIDER_MARGIN}px`;
export const componentStyles = new String(`.integrations-slider-component.jsx-bcc8ef5a18791482{position:relative;padding:${SLIDER_MARGIN_PX} 0;.integration-badge-wrapper{position:absolute}}`);
componentStyles.__hash = "bcc8ef5a18791482";
